module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;
    import Employee = Meevo.Model.Employee;
    import Service = Meevo.Model.Service;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    interface IServiceIsBookedJson extends IAlertJSON {
        services?: string[];
        employees?: string[];
        defaultFilterValue?: any;
    }

    class EmployeeServiceMoversConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$translate',
            '$scope'
        ];

        public params: IParams;
        public data: ISingleMoverData;

        public selectedServices: Service[];
        public selectedEmployees: Employee[];

        public employeeCriteria = {
            showEmployeesOnly: false,
            objectStateEnumList: [ObjectStateEnum.Active, ObjectStateEnum.Inactive],
        };

        public readonly dataForReviewTemplate: string;

        public defaultFilterValue: any;

        get dataForReview() {
            return [
                {
                    services: (this.selectedServices || []).map((item) => item.displayName),
                    employees: (this.selectedEmployees || []).map((item) => item.displayName)
                }
            ]
        }

        get alertConfiguration() {
            return {
                services: (this.selectedServices || []).map((item) => item.id),
                employees: (this.selectedEmployees || []).map((item) => item.id),
                defaultFilterValue: this.defaultFilterValue,
            };
        }

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected $translate: ng.translate.ITranslateService,
                    protected $scope: ng.IScope) {
            super(alertsManagerService);
            this.dataForReviewTemplate = 'EmployeeServiceMoverConfig';
        }

        $onInit() {
            super.$onInit();
        }

        onEdit(alertJSON: IServiceIsBookedJson): void {
            this.selectedServices = (alertJSON.services || []);
            this.defaultFilterValue = alertJSON.defaultFilterValue;
            this.selectedEmployees = (alertJSON.employees || []);
        }

        onMoverFilterChanged(values: any) {
            this.defaultFilterValue = values;
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoEmployeeServiceMoversConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/employee-service-movers-config/employee-service-movers-config.component.html',
            controller: EmployeeServiceMoversConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}
